module.exports = __webpack_public_path__ + "img/medal-quiz.c3b3ac9a.png";